(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yc-product-filter"] && !Shopify.designMode) return;
  try {
    const optionElements = document.querySelectorAll('.yc-product-filter__options');
  const backButtons = document.querySelectorAll('.yc-product-filter__back');
  const filtersContainer = document.querySelector('.yc-product-filter__filters');
  const filtersWrapper = document.querySelector('.yc-product-filter__filters-wrapper');

  const toggleButton = document.querySelector('.yc-product-filter__toggle-button');

  const closeButtons = document.querySelectorAll('.yc-product-filter__close');

  toggleButton.addEventListener('click', function() {
    //console.log('Toggle filters');
    filtersWrapper.classList.toggle('filter-show');
    document.querySelector('.yc-product-filter__filters-vail').classList.toggle('show-vail');
  });



  function closeFilters() {
    filtersWrapper.classList.remove('filter-show');
    document.querySelector('.yc-product-filter__filters-vail').classList.remove('show-vail');

    // close all options
    optionElements.forEach(function(option) {
        option.style.maxHeight = null;
        option.classList.remove('is-active');
    });

    // remove active class from all toggles
    document.querySelectorAll('.yc-product-filter__toggle').forEach(function(toggle) {
      toggle.classList.remove('is-active');
    });

    filtersContainer.classList.remove('filter-options-open');

  }
  closeButtons.forEach(function(button) {
    button.addEventListener('click', closeFilters);
  });


  document.querySelectorAll('.yc-product-filter__toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {

      toggle.classList.toggle('is-active');

      const currentOption = toggle.nextElementSibling;
     
      
      // close all options
      optionElements.forEach(function(option) {
        if(option.id !== currentOption.id){
          option.style.maxHeight = null;
          option.classList.remove('is-active');
        }
      });

      currentOption.style.maxHeight = currentOption.style.maxHeight ? null : currentOption.scrollHeight + 'px';
      currentOption.classList.toggle('is-active');

      filtersContainer.classList.add('filter-options-open');
      

    });
  });

   backButtons.forEach(function(button){

      button.addEventListener('click', function() {
        const currentOption = button.closest('.yc-product-filter__options');

         optionElements.forEach(function(option) {
          option.style.maxHeight = null;
          option.classList.remove('is-active');
     
        });

        // remove active class from all toggles
        document.querySelectorAll('.yc-product-filter__toggle').forEach(function(toggle) {
          toggle.classList.remove('is-active');
        });

        filtersContainer.classList.remove('filter-options-open');

      });

   })

  


  // form 
  const filterForm = document.getElementById('yc-product-filter__form');

  filterForm.addEventListener('input', function() {


    // through the fields and collect the data then fetch
    // this dosen't work. There can be more than one category selected
    const formData = new FormData(filterForm);
    const filters = Object.fromEntries(formData.entries());

    /// get all fields and build a query string
    const formFields = filterForm.querySelectorAll("input")
    let formQueryString = '';
    formFields.forEach(field =>{
      //console.log(field.checked,field.name,field.value,field.type);
      if(field.checked){
        formQueryString += `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}&`;
      }
    });
    //console.log("Filters applied:", filters,formQueryString);

    // fetch the form action url and add the form data

    const fetchUrlString = filterForm.action + '?' + formQueryString;

    //console.log("Fetch URL:", fetchUrlString);

    document.querySelector('#productGridProducts').style.opacity = 0.5;

    // update the browser history
    history.pushState(null, '', fetchUrlString);

    fetch(fetchUrlString, {
      method: 'GET',    })
    .then(response => response.text())
    .then(htmlString => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      const newContent = doc.querySelector('#productGridProducts').innerHTML;
      const newHiddenProducts = doc.querySelector('#hiddenProducts').innerHTML;

      const allProductsCount = doc.querySelector('.yc-product__product-count-number').textContent;
      document.querySelector('.yc-product__product-count-number').textContent = allProductsCount;


      document.querySelector('#productGridProducts').innerHTML = newContent;
      document.querySelector('#hiddenProducts').innerHTML = newHiddenProducts;
      document.querySelector('#productGridProducts').style.opacity= 1;



      // loop through all the filters on the loaded page and apply the attributes to the current page
      const newFilters = doc.querySelectorAll('.yc-product-filter .yc-product-filter__checkbox-label');
      newFilters.forEach(function(newFilter) {

        const currentFilterLabel = filterForm.querySelector(`label[data-field-value="${newFilter.dataset.fieldValue}"]`);
        const newFilterInput = newFilter.querySelector('input');
        const currentFilterInput = currentFilterLabel.querySelector('input');

        const currentFilterCount = currentFilterLabel.querySelector('.yc-product__product-count-number');
        const newFilterCount = newFilter.querySelector('.yc-product__product-count-number');

        // update the count
        if(currentFilterCount && newFilterCount){
          currentFilterCount.textContent = newFilterCount.textContent;
          currentFilterCount.classList.add('updated');
        }
        // update the input attributes
        if(currentFilterInput && newFilterInput){
          currentFilterInput.checked = newFilterInput.checked;
          currentFilterInput.disabled = newFilterInput.disabled;
          currentFilterInput.value = newFilterInput.value;
        }
    
      });

      // if product grid is above the the browser scroll to the top.
      if (document.querySelector('#productGridProducts').getBoundingClientRect().top < 0) {

          const newScrollPosition = document.querySelector('#productGridProducts').offsetTop - 100

          window.scrollTo({
              top: newScrollPosition,
              behavior: 'smooth'
          });
      }

    })
    .catch(error => {
      console.error("Fetch error:", error);
    });

  });



  // Clear all filters

  const clearButtons = document.querySelectorAll('.yc-clear-all-filters');

  clearButtons.forEach(function(clearButton) {
    clearButton.addEventListener('click', function() {
      /*
      const filterForm = document.getElementById('yc-product-filter__form');
      const formFields = filterForm.querySelectorAll("input")
      let formQueryString = '';
      formFields.forEach(field =>{
        field.checked = false;
        //field.attributes.remove('checked');
        field.value = '';

        console.log('field cleared',field)
      });
      console.log('Clear all filters');
      history.pushState(null, '', filterForm.action);

      // Trigger the input event to update the product grid
      filterForm.dispatchEvent(new Event('input'));
      */
      // goto paint collection page
      window.location.href = '/collections/paint';
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yc-promo-card"] && !Shopify.designMode) return;
  try {
    const promoCards = document.querySelectorAll('.yc-promo-card');
    const setHeightOfBlurredOverlay = (card) => {   
        const contentHeight = card.querySelector('.yc-promo-card__content').offsetHeight;
        const overlay = card.querySelector('.yc-promo-card__background-overlay');
        if(overlay){
            const overlayHeight = contentHeight + 60; // extra to cover padding
            overlay.style.height = `${overlayHeight}px`;
        }
    }
    promoCards.forEach(card => {
        setHeightOfBlurredOverlay(card);
    });
    window.addEventListener('resize', () => {
        promoCards.forEach(card => {
            setHeightOfBlurredOverlay(card);
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yc-reading-progress-bar"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    const progressBar = document.querySelector('.yc-reading-progress-bar__progress');
    const progressBarContainer = document.querySelector('.yc-reading-progress-bar');

    function updateProgressBar() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;
      progressBar.style.width = scrollPercent + '%';

      if(scrollTop > 400){
        progressBarContainer.classList.add('scrolled-down');
      }else{
        progressBarContainer.classList.remove('scrolled-down');
      }
    }

    window.addEventListener('scroll', updateProgressBar);
    updateProgressBar();
  });
  } catch(e) { console.error(e); }
})();

})();
